import { ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { DtoBase } from "..";

export class AuditLogSettingsDto extends DtoBase {
    log_admin_actions: boolean = false;
    log_login_actions: boolean = false;
    log_password_actions: boolean = false;
    log_network_change_actions:boolean = false;

    public Write(obj: any, context: any): void {
		obj.audit_log_settings = {};
		obj = obj.audit_log_settings;

        super.Write(obj, context);

        obj.log_admin_actions = ValueEncoder.EncodeBoolean(this.log_admin_actions);
        obj.log_login_actions = ValueEncoder.EncodeBoolean(this.log_login_actions);
        obj.log_password_actions = ValueEncoder.EncodeBoolean(this.log_password_actions);
        obj.log_network_change_actions = ValueEncoder.EncodeBoolean(this.log_network_change_actions);
	}

	public Read(obj: any, context: any): void {

		if (!obj.audit_log_settings)
			throw new Error();
		obj = obj.audit_log_settings;

		super.Read(obj, context);

        if(obj.log_admin_actions !== undefined) {
            this.log_admin_actions = ValueEncoder.DecodeBoolean(obj.log_admin_actions)
        }

        if(obj.log_login_actions !== undefined) {
            this.log_login_actions = ValueEncoder.DecodeBoolean(obj.log_login_actions)
        }

        if(obj.log_password_actions !== undefined) {
            this.log_password_actions = ValueEncoder.DecodeBoolean(obj.log_password_actions)
        }

        if(obj.log_network_change_actions !== undefined) {
            this.log_network_change_actions = ValueEncoder.DecodeBoolean(obj.log_network_change_actions)
        }
	}
}